import { createClient } from '@supabase/supabase-js';

// Supabase 配置
// 注意：实际项目中这些应该从环境变量读取
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your-anon-key';

// 创建 Supabase 客户端
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// 数据库表名
export const TABLES = {
  USERS: 'users',
  CONTENT: 'content',
  SURVEYS: 'surveys',
  MODELS: 'models',
  STYLES: 'styles',
  CLOTHES: 'clothes',
  CONFIDENTIALITY_AGREEMENTS: 'confidentiality_agreements'
};

// 存储桶名
export const BUCKETS = {
  IMAGES: 'images',
  AVATARS: 'avatars'
};

export default supabase;
